var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"loading"},[_c('div',{staticClass:"uil-ring-css",staticStyle:{"transform":"scale(0.79)"}},[_c('div'),_c('h1',{staticClass:"load-i"},[_c('i',{staticClass:"fa fa-info",attrs:{"aria-hidden":"true"}})])])])
}]

export { render, staticRenderFns }